import React from "react"
import { useSession } from "lib/auth/react/session"
import { AppLoadingSpinner } from "components/atoms/AppLoadingSpinner"

interface SessionAuthWrapperProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const SessionAuthWrapper: React.FC<SessionAuthWrapperProps> = ({ 
  children, 
  fallback = <AppLoadingSpinner />
}) => {
  const { data: sessionData, isLoading, error } = useSession()
  
  // Session is still loading - show fallback
  if (isLoading) {
    return <>{fallback}</>
  }
  
  // Session loaded (whether successful or failed) - render app
  // Auth status cache is now correctly set by useSession
  return <>{children}</>
}